import type { ChangeEventHandler } from 'react';

type HoneypotFieldProps = {
  id: string;
  name: string;
  label: string;
  value: string;
  onChange: ChangeEventHandler<HTMLInputElement>;
};

const HoneypotField: React.FC<HoneypotFieldProps> = ({ id, name, label, value, onChange }) => {
  return (
    <div
      aria-hidden="true"
      style={{ position: 'absolute', left: '-5000px', width: '1px', height: '1px', overflow: 'hidden' }}
    >
      <label htmlFor={id}>{label}</label>
      <input id={id} type="text" name={name} autoComplete="off" value={value} onChange={onChange} tabIndex={-1} />
    </div>
  );
};

export default HoneypotField;
